import { useQuery } from '@tanstack/react-query';
import { BankingInfoForm } from './BankingInfoForm';
import { getBankingInformation } from '../../../../services/digital-dossiers/get-information';
import { Center, Spinner } from '@agrotoken-tech/ui';
import { SectionError } from '../components/SectionError';
import { useTranslation } from '@bcba/react-hooks';

export const BankingInfo = () => {
  const { t } = useTranslation();
  const { data, isPending, isError, refetch } = useQuery({
    queryKey: ['banking-info'],
    queryFn: getBankingInformation,
  });

  if (isError)
    return (
      <SectionError
        message={t('explorer.digitalDossier.getBankingInfo.error')}
      />
    );

  if (isPending || !data)
    return (
      <Center mt="8">
        <Spinner />
      </Center>
    );

  return <BankingInfoForm data={data} refetch={refetch} />;
};
